module.exports = __webpack_public_path__ + "img/1545218946.57af8bd2.jpg";